"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAPI = void 0;
var core_1 = require("../../../core");
var BaseAPI = /** @class */ (function () {
    function BaseAPI(req, chains) {
        this.req = req;
        this.chains = chains;
    }
    BaseAPI.prototype.getReqFromChainID = function (chainID) {
        return this.req[chainID];
    };
    BaseAPI.prototype.getPrefix = function (address) {
        var addressTypes = [
            core_1.AccPubKey,
            core_1.ValAddress,
            core_1.ValConsAddress,
            core_1.ValPubKey,
            // this must be the last one
            core_1.AccAddress,
        ];
        for (var _i = 0, addressTypes_1 = addressTypes; _i < addressTypes_1.length; _i++) {
            var addressType = addressTypes_1[_i];
            if (addressType.validate(address)) {
                return addressType.getPrefix(address);
            }
        }
        throw new Error("The provided address (".concat(address, ") is not valid."));
    };
    BaseAPI.prototype.getReqFromAddress = function (address) {
        var prefix = this.getPrefix(address);
        var chain = Object.values(this.chains).filter(function (chain) { return prefix === chain.prefix; })[0];
        if (!chain)
            throw new Error("There is no chain configured with the '".concat(prefix, "' prefix."));
        return this.req[chain.chainID];
    };
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
//# sourceMappingURL=BaseAPI.js.map